import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * ValuationAssumptions Widget
 */
@Component({
  selector: 'valuation-assumptions-widget',
  templateUrl: './valuation-assumptions-widget.component.html',
  styleUrls: ['../../common/css/general.scss','./valuation-assumptions-widget.component.scss']
})
export class ValuationAssumptionsWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'valuationAssumptions', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    const self = this; // Kendo - keep it
    this.textAreaOptions = {
      change: function () {
        self.setDirtyFlag(true);
      },
      update: function (text) {
        self.widgetData.Comment = text;
      },
    };

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("valuationAssumptions", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('valuationAssumptions').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('valuationAssumptions', this.getReport()).pipe();
  }

  /**
   * Returns chart label content
  * @param e {any} Event object
   */
  labelContent(e: any): string {
    return `${e.category} : ${e.value}%`;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

}
